import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';
import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';
import { State, UserCityResponse, UserRoleResponse, UserStateResponse } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';


export type requestDTOUploadImage = {
    file: FormData;
  };
  
  export type UploadImageResponse = {
    fileUrl: string;
  };
  
  export const updateQuotess = ({
    file,
  }: requestDTOUploadImage): Promise<UploadImageResponse> => {
    return axios.post('/account/upload/file', file);
  };
  
  type UseUpdateInstituteOptions1 = {
    config?: MutationConfig<typeof updateQuotess>;
  };
  
export const useGetQuotesUpdate= ({ config }: UseUpdateInstituteOptions1 = {}) => {
  return useMutation({
    ...config,
    mutationFn: updateQuotess,
  });
};



export type requestDTO = {
    groupId?: any;
    remarks?: any;
    statusId: any;
    approvedAmount?: any
};

export const updateQuote = ({ approvedAmount, groupId, statusId, remarks }: requestDTO) => {

    return axios.post(`/account/update-claim`, { approvedAmount, groupId, statusId, remarks });

};

type UseAddUserOptions = {
  config?: MutationConfig<typeof updateQuote>;
};

export const useUpdateQuote = ({ config }: UseAddUserOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Claim updated successfully',
      });
    },
    ...config,
    mutationFn: updateQuote,
  });
};
